/**
 * @file: 运行时环境变量
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2022-05-23 18:54:37
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2023-12-07 15:36:41
 * @FilePath: /console-znzs/src/utils/env.js
 */
import {isNil} from 'lodash-es';
/**
 * 判断是否为沙盒环境
 */
export const isSandbox = /bcetest.baidu.com/.test(location.href) || location.host.includes('test');

/**
 * 根据预设变量或者页面路径判断是否是游客页面
 */
export const isTourist = !isNil(window.isPresale)
    ? window.isPresale
    : (location.pathname.includes('tourist') || location.pathname.includes('znzs/pre-sale'));

export const isDev = process.env.VUE_APP_ENV === 'local' || process.env.NODE_ENV !== 'production';

/**
 * 埋点环境
 */
export const appTag = 'znzs' + (isTourist ? '-tourist' : '') + (isDev ? '-dev' : isSandbox ? '-sandbox' : '-online');